import React from 'react';
import { Navigate } from 'react-router-dom';

// Redirecting to Home page since Home now contains all services in a comprehensive grid.
// This keeps the routing clean as requested.
const ServicePlansPage = () => {
  return <Navigate to="/" replace />;
};

export default ServicePlansPage;